import React, { useState, useEffect } from "react";
import styles from "./Addresses.module.css";

function Addresses() {
  const [totalAddrs, setTotalAddrs] = useState(0);
  const [date, setDate] = useState("");
  const [loading, setLoading] = useState(true);
  const possibleAddrs =
    "1,461,501,637,330,902,918,203,684,832,716,283,019,655,932,542,976";

  useEffect(() => {
    fetch("stats/addrs")
      .then((resp) => resp.json())
      .then((data) => {
        setTotalAddrs(data.total_addresses_created);
        setDate(data.date);
        setLoading(false);
      })
      .catch((err) => console.log(err.message));
  }, []);

  const commaFormat = new Intl.NumberFormat();

  return (
    <div className="mbox">
      <h4 className="text-center mb-5" title="Bitcoin addresses are unique identifiers that hold (or held) Bitcoin. Total BTC addresses ever created indicates the total number of unique addresses that ever appeared in transaction(s) in the Bitcoin network.">
        <i className="bi bi-battery-half" style={{ color: "darkorange" }}></i>{" "}
        Bitcoin Addresses
      </h4>
      <table
        className={`${styles.fixed} table table-striped`}
        aria-labelledby="tabelLabel"
      >
        <tbody>
          <tr>
            <th className={styles.tlabel}>Total possible BTC addresses: </th>
            <td className={styles.tdata}>
              {possibleAddrs}
              <br />( 2^160 )
            </td>
          </tr>
          <tr>
            <th className={styles.tlabel}>
              Total BTC addresses ever created so far:{" "}
            </th>
            {loading ? (
              <td className={styles.tdata} style={{ fontStyle: "italic" }}>
                Loading...
              </td>
            ) : (
              <td
                className={styles.tdata}
                style={{ color: "green", fontWeight: "bold" }}
              >
                {commaFormat.format(totalAddrs)}
                <br />
                <span
                  style={{ fontSize: 10, color: "black", fontWeight: "normal" }}
                >
                  (as of {date})
                </span>
              </td>
            )}
          </tr>
        </tbody>
      </table>
      <br />
      <div style={{ fontSize: 11 }} className="mt-5">
        <span className="p-2">source: glassnode</span>
      </div>
    </div>
  );
}

export default Addresses;
